import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { logError } from '@sequencehq/utils'
import { getApiErrorMessage } from 'Cube/utils/getApiErrorMessage'

export const useCreateTaxCategoryWithAnrokMapping = () => {
  const { displayNotification } = useNotifications()

  const createTaxCategoryMutator = useMutation(
    dashboardv99990101Client.postTaxCategory
  )

  return async ({
    taxCategoryName,
    description
  }: {
    taxCategoryName: string
    description: string
  }) => {
    try {
      const result = await createTaxCategoryMutator.mutateAsync({
        body: {
          name: taxCategoryName,
          description,
          isPublished: true,
          version: 0
        }
      })

      if (!result?.id) {
        throw new Error('No ID returned from tax category creation')
      }

      displayNotification('Tax category created', {
        type: 'success'
      })
    } catch (error) {
      logError(error)

      const backendMessage = getApiErrorMessage(error, '')
      const errorMessage = backendMessage
        ? `Failed to create tax category: ${backendMessage}`
        : 'Failed to create tax category'

      displayNotification(errorMessage, {
        type: 'error'
      })
      throw error
    }
  }
}
